/**
 * `admin` administre la plateforme (clubs, comptes) et garde la boutique en
 * plus ; `shop_admin` n'administre que la boutique.
 */
/**
 * `amateur` : le supporter. Il s'inscrit au numéro de téléphone et à un code,
 * suit des clubs, des joueurs et des entraîneurs, et ne gère rien.
 */
/**
 * `photographer` : le photographe de match. Téléphone et code comme le
 * supporter ; il vend ses photos et répond aux réservations des clubs.
 */
export type UserType = 'player' | 'coach' | 'club' | 'amateur' | 'photographer' | 'admin' | 'shop_admin';

/** Rôles autorisés sur l'espace boutique. */
export const SHOP_ADMIN_ROLES: UserType[] = ['admin', 'shop_admin'];

export interface User {
  id: string;
  email: string;
  user_type: UserType;
  phone?: string;
  first_name?: string;
  last_name?: string;
  name?: string; // Pour les clubs
  avatar_url?: string;
  cover_image_url?: string;
  is_verified: boolean;
  is_active: boolean;
  email_verified_at?: string;
  phone_verified_at?: string;
  last_login_at?: string;
  created_at: string;
  updated_at: string;
}

export interface AuthTokens {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export interface RegisterRequest {
  email: string;
  password: string;
  user_type: UserType;
  first_name?: string;
  last_name?: string;
  name?: string; // Pour les clubs
  phone?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data: {
    user: User;
    tokens: AuthTokens;
  };
}

export interface UserResponse {
  success: boolean;
  data: {
    user: User;
  };
}

export interface ApiError {
  success: false;
  message: string;
  errors?: string[];
}

export interface ActiveUser {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  user_type: UserType;
  avatar_url?: string;
  posts_count: number;
  last_login_at?: string;
}

export interface ActiveUsersResponse {
  success: boolean;
  data: {
    users: ActiveUser[];
    count: number;
  };
}
